import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr'
import {
  FLAG_GETTING_LEGAL_MANIFEST_TICKETS,
  GET_LEGAL_MANIFEST_TICKETS,
  CLEAR_LEGAL_MANIFEST_TICKETS
} from '../types'

import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { LEGAL_MANIFEST_TICKET_ENDPOINT } from '../../config/endpoints';

const flagGettingManifestTickets = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_LEGAL_MANIFEST_TICKETS,
    payload: flag
  });

const clearLegalManifestTickets = () => (dispatch) =>
  dispatch({
    type: CLEAR_LEGAL_MANIFEST_TICKETS
  });

const getLegalManifestTickets = async (filters) => async (dispatch) => {
  try {
    dispatch(flagGettingManifestTickets(true));
    const query = filters;
    const url = `${LEGAL_MANIFEST_TICKET_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const legalManifestTickets = await response.json();
    dispatch({
      type: GET_LEGAL_MANIFEST_TICKETS,
      payload: legalManifestTickets
    });
  }
  catch (error) {
    toastr.error('Error', error.message);
  }
  finally {
    dispatch(flagGettingManifestTickets(false));
  }
}

const getLegalManifestTicketDetail = async ({ idSourceSystem }) => async () => {
  try {
    const url = `${LEGAL_MANIFEST_TICKET_ENDPOINT}/${idSourceSystem}/detail`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    const legalManifestTicketDetail = await response.json();
    return legalManifestTicketDetail;
  } catch (error) {
    toastr.error('Error', error.message);
    return {};
  }
}

export {
  flagGettingManifestTickets,
  getLegalManifestTickets,
  clearLegalManifestTickets,
  getLegalManifestTicketDetail
};